
<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPurchaseOrders"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-purchase-order-number" label-cols-sm="4" label-cols-lg="3" label="Purchase Order Number" label-for="filter-purchase-order-number" size="sm" :model.sync="filter.purchaseOrderNumber" />
					<app-input-combobox-autocomplete :options="purchaseRequests" optionsLabel="purchaseRequestNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Purchase Request Number" id="filter-" size="sm" :model.sync="filter.purchaseRequestId" @input="getPurchaseRequests" @focus="getPurchaseRequests" />
					<app-input-datepicker-range  id="fieldset-purchase-order-date" label-cols-sm="4" label-cols-lg="3" label="Purchase Order Date" size="sm" :modelFrom.sync="filter.purchaseOrderDateFrom" :modelTo.sync="filter.purchaseOrderDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datepicker-range  id="fieldset-delivery-date-request" label-cols-sm="4" label-cols-lg="3" label="Delivery Date Request" size="sm" :modelFrom.sync="filter.deliveryDateRequestFrom" :modelTo.sync="filter.deliveryDateRequestTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Po Status" id="filter-" size="sm" :model.sync="filter.poStatusId" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm" :model.sync="filter.vendorId" @input="getVendors" @focus="getVendors" />
					<app-input-textarea id="fieldset-purpose" label-cols-sm="4" label-cols-lg="3" label="Purpose" label-for="filter-purpose" size="sm" :model.sync="filter.purposeMultiple" />
					<app-input-textarea id="fieldset-remark" label-cols-sm="4" label-cols-lg="3" label="Remark" label-for="filter-remark" size="sm" :model.sync="filter.remarkMultiple" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-total-qty-from" label-cols-sm="4" label-cols-lg="3" label="Total Qty From"
						size="sm" :model.sync="filter.totalQtyFrom" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-total-qty-to" label-cols-sm="4" label-cols-lg="3" label="Total Qty To"
						size="sm" :model.sync="filter.totalQtyTo" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-total-amount-qty-from" label-cols-sm="4" label-cols-lg="3" label="Total Amount Qty From"
						size="sm" :model.sync="filter.totalAmountFrom" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-total-amount-qty-to" label-cols-sm="4" label-cols-lg="3" label="Total Amount Qty To"
						size="sm" :model.sync="filter.totalAmountTo" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-total-price-ppn-from" label-cols-sm="4" label-cols-lg="3" label="Total Price Ppn From"
						size="sm" :model.sync="filter.totalPricePpnFrom" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-total-price-ppn-to" label-cols-sm="4" label-cols-lg="3" label="Total Price Ppn To"
						size="sm" :model.sync="filter.totalPricePpnFrom" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-quotation-number" label-cols-sm="4" label-cols-lg="3" label="Quotation Number" label-for="filter-quotation-number" size="sm" :model.sync="filter.quotationNumber" />
					<app-input-datepicker-range  id="fieldset-quotation-date" label-cols-sm="4" label-cols-lg="3" label="Quotation Date" size="sm" :modelFrom.sync="filter.quotationDateFrom" :modelTo.sync="filter.quotationDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-textbox id="fieldset-ppn-from" label-cols-sm="4" label-cols-lg="3" label="Ppn From"
						size="sm" :model.sync="filter.ppnFrom" :isEditable="true"
						type="number" />
					<app-input-textbox id="fieldset-ppn-to" label-cols-sm="4" label-cols-lg="3" label="Ppn To"
						size="sm" :model.sync="filter.ppnTo" :isEditable="true"
						type="number" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPurchaseOrders"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Purchase Order</span>
				</b-col>
				<b-col v-if="false">
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm" v-if="(userRole != null && (userRole.allowDownload ||userRole.allowUpload||userRole.allowPrint))">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/purchaseorder/PurchaseOrder.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpload : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData" v-if="userRole != null ? userRole.allowDownload : false"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-purchaseorder" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="purchaseOrders" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="purchaseOrders.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Purchase Order Number" class="table-filter">
					<b-form-input id="input-purchase-order-number-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.purchaseOrderNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Purchase Request Number" class="table-filter">
					<v-select append-to-body label="purchaseRequestNumber" :options="purchaseRequests" :value="filter.purchaseRequestId" :reduce="item => item.id" v-model="filter.purchaseRequestId" :filterable="true" @input="getPurchaseOrdersWithoutLoading" @search="getPurchaseRequests"></v-select>
				</b-th>
				<b-th stacked-heading="Purchase Order Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-purchase-order-date-from-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.purchaseOrderDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-purchase-order-date-to-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.purchaseOrderDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Delivery Date Request" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-request-from-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.deliveryDateRequestFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-delivery-date-request-to-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.deliveryDateRequestTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Purpose" class="table-filter">
					<b-form-input id="input-purpose-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.purpose" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark" class="table-filter">
					<b-form-input id="input-remark-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.remark" size="sm"></b-form-input>
				</b-th> 
				<b-th stacked-heading="Total Qty" class="table-filter">
					<b-form-input id="input-total-qty-from-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalQtyFrom"
								size="sm" type="number"></b-form-input>
					<b-form-input id="input-total-qty-to-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalQtyTo"
						size="sm" type="number"></b-form-input>
				</b-th>
				<b-th stacked-heading="Total Amount" class="table-filter">
					<b-form-input id="input-total-amount-from-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalAmountFrom"
								size="sm" type="number"></b-form-input>
					<b-form-input id="input-total-amount-to-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalAmountTo"
						size="sm" type="number"></b-form-input>
				</b-th>
				<b-th stacked-heading="Po Status" class="table-filter">
					<v-select append-to-body label="name" :options="documentStatuss" :value="filter.poStatusId" :reduce="item => item.id" v-model="filter.poStatusId" :filterable="true" @input="getPurchaseOrdersWithoutLoading" @search="getDocumentStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Total Price Ppn" class="table-filter">
					<b-form-input id="input-total-price-ppn-from-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalPricePpnFrom"
								size="sm" type="number"></b-form-input>
					<b-form-input id="input-total-price-ppn-to-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.totalPricePpnTo"
						size="sm" type="number"></b-form-input>
				</b-th>
				<b-th stacked-heading="Vendor" class="table-filter">
					<v-select append-to-body label="code" :options="vendors" :value="filter.vendorId" :reduce="item => item.id" v-model="filter.vendorId" :filterable="true" @input="getPurchaseOrdersWithoutLoading" @search="getVendors"></v-select>
				</b-th>
				<b-th stacked-heading="Contact Person" class="table-filter">
				</b-th>
				<b-th stacked-heading="Quotation Number" class="table-filter">
					<b-form-input id="input-quotation-number-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.quotationNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Quotation Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-quotation-date-from-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.quotationDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-quotation-date-to-table" reset-button @input="getPurchaseOrdersWithoutLoading" v-model="filter.quotationDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="ppn" class="table-filter">
					<b-form-input id="input-ppn-from-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.ppnFrom"
								size="sm" type="number"></b-form-input>
					<b-form-input id="input-ppn-to-table" @input="getPurchaseOrdersWithoutLoading" v-model="filter.ppnTo"
								size="sm" type="number"></b-form-input>
				</b-th>
				</template>
				<template v-slot:cell(no)="row">
					{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
				</template>

				<template v-slot:cell(purchaseordernumber)="row">
					<a @click="() => ( $router.push({ name: 'purchaseorderdetail', params : { id: row.item.id } }))" class="a-link-detail">
						{{ row.item.purchaseOrderNumber != null && row.item.purchaseOrderNumber != "" ?
							(typeof row.item.productCode == 'string') ?
								row.item.purchaseOrderNumber.slice(0, 30) + (row.item.purchaseOrderNumber.length > 30 ? "..." : "" ) : row.item.purchaseOrderNumber : "" }}
					</a>
				</template>

			<template v-slot:cell(purchaseRequest)="row">
				{{ row.item.purchaseRequest != null ? row.item.purchaseRequest.purchaseRequestNumber : "" }}
			</template>
			<template v-slot:cell(purchaseOrderDate)="row">
				{{ row.item.purchaseOrderDate | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(deliveryDateRequest)="row">
				{{ row.item.deliveryDateRequest | moment("DD-MMM-YYYY") }}
			</template>
				<template v-slot:cell(purpose)="row">
					<app-long-text  :id="'purpose-' + row.index" :text="row.item != null ? (row.item.purpose != null && row.item.purpose != '' ? row.item.purpose : '') : ''" />
				</template>
				<template v-slot:cell(remark)="row">
					<app-long-text  :id="'remark-' + row.index" :text="row.item != null ? (row.item.remark != null && row.item.remark != '' ? row.item.remark : '') : ''" />
				</template>
			<template v-slot:cell(vendor)="row">
				{{ row.item.vendor != null ? row.item.vendor.code : "" }}
			</template>
			<template v-slot:cell(contactPerson)="row">
				{{ row.item.vendor != null ? row.item.vendor.contactPerson : "" }}
			</template>
			<template v-slot:cell(quotationDate)="row">
				{{ row.item.quotationDate | moment("DD-MMM-YYYY") }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template v-slot:cell(totalQty)="row">
						<app-input-textbox :id="'input-total-qty-' + (row.index + 1)" label-cols-lg="12"
							label="Total Qty" size="sm" :model.sync="row.item.totalQty" :isEditable="false"
							:thousandSeparator="true" />
					</template>
					<template v-slot:cell(totalAmount)="row">
						<app-input-textbox :id="'input-total-amount-' + (row.index + 1)" label-cols-lg="12"
							label="Total Amount" size="sm" :model.sync="row.item.totalAmount" :isEditable="false"
							:thousandSeparator="true" />
					</template>
					<template v-slot:cell(totalPricePpn)="row">
						<app-input-textbox :id="'input-total-price-ppn-' + (row.index + 1)" label-cols-lg="12"
							label="Total Price Ppn" size="sm" :model.sync="row.item.totalPricePpn" :isEditable="false"
							:thousandSeparator="true" />
					</template>
					<template v-slot:cell(poStatus)="row">
						<app-input-textbox :id="'input-po-status-' + (row.index + 1)" label-cols-lg="12"
							label="Po Status" size="sm" :model.sync="row.item.poStatusName" :isEditable="false"/>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-datepicker  id="fieldset-purchase-order-date" label-cols-lg="12"  label="Purchase Order Date" size="sm" :model.sync="row.item.purchaseOrderDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
							<app-input-datepicker  id="fieldset-delivery-date-request" label-cols-lg="12"  label="Delivery Date Request" size="sm" :model.sync="row.item.deliveryDateRequest"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
							<app-input-textarea id="fieldset-purpose" label-cols-lg="12"  label="Purpose" label-for="input-purpose" size="sm" :model.sync="row.item.purpose"   :isEditable="false" :isUpdatable="true" />
							<app-input-textarea id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="row.item.remark"   :isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.vendorId" label="Vendor" :selected="row.item.vendor != null ? row.item.vendor.code : ''" :isEditable="false" :isUpdatable="true" />
							<app-label label-cols-lg="12" size="sm" label="Contact Person" :model="(model.vendor != null) ? model.vendor.contactPerson : null"  />
							<app-input-textbox id="fieldset-quotation-number" label-cols-lg="12"  label="Quotation Number" label-for="input-quotation-number" size="sm" :model.sync="row.item.quotationNumber"   :isEditable="false" :isUpdatable="true" />
							<app-input-datepicker  id="fieldset-quotation-date" label-cols-lg="12"  label="Quotation Date" size="sm" :model.sync="row.item.quotationDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(purchaseOrdersPaging != null ? purchaseOrdersPaging.dataCount : 0)"
									:per-page="(purchaseOrdersPaging != null ? purchaseOrdersPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-purchaseorder.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-purchaseorder.b-table>thead>tr>th {
	background: #e28b29;
}

    ::v-deep #table-list-purchaseorder.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderList from '@/models/PurchaseOrder/PurchaseOrderList';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import RoleDetail from '@/models/Core/RoleDetail';


import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		PurchaseOrder, 
		PurchaseOrderList, 
		PurchaseOrderFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"purchaseOrderNumber": {}, "class" : "th-purchase-order-number first-child", "label" : "Purchase Order Number", key: 'purchaseOrderNumber', sortable: true}, 
				{"purchaseRequest": {}, "class" : "th-purchase-request", "label" : "Purchase Request Number", key: 'purchaseRequest', sortable: true}, 
				{"purchaseOrderDate": {}, "class" : "th-purchase-order-date last-child", "label" : "Purchase Order Date", key: 'purchaseOrderDate', sortable: true}, 
				{"deliveryDateRequest": {}, "class" : "th-delivery-date-request d-stack-none", "label" : "Delivery Date Request", key: 'deliveryDateRequest', sortable: true}, 
				{"purpose": {}, "class" : "th-purpose d-stack-none", "label" : "Purpose", key: 'purpose', sortable: true}, 
				{"remark": {}, "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: true}, 
				{"totalQty": {}, "class" : "th-total-qty d-stack-none", "label" : "Total Qty", key: 'totalQty', sortable: true}, 
				{"totalAmount": {}, "class" : "th-total-amount d-stack-none", "label" : "Total Amount", key: 'totalAmount', sortable: true}, 
				{"poStatus": {}, "class" : "th-po-status d-stack-none", "label" : "Po Status", key: 'poStatus', sortable: true}, 
				{"totalPricePpn": {}, "class" : "th-total-price-ppn d-stack-none", "label" : "Total Price Ppn", key: 'totalPricePpn', sortable: true}, 
				//{"revisi": {}, "class" : "th-revisi d-stack-none", "label" : "Revisi", key: 'revisi', sortable: true}, 
				{"vendor": {}, "class" : "th-vendor d-stack-none", "label" : "Vendor", key: 'vendor', sortable: true}, 
				{"contactPerson": {}, "class" : "th-contact-person d-stack-none", "label" : "Contact Person", key: 'contactPerson', sortable: true}, 
				{"quotationNumber": {}, "class" : "th-quotation-number d-stack-none", "label" : "Quotation Number", key: 'quotationNumber', sortable: true}, 
				{"quotationDate": {}, "class" : "th-quotation-date d-stack-none", "label" : "Quotation Date", key: 'quotationDate', sortable: true}, 
				{"ppn": {}, "class" : "th-ppn d-stack-none", "label" : "Ppn", key: 'ppn', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			purchaseOrders: [],
			purchaseOrdersPaging: {},
			purchaseRequests : [],
			vendors : [],
			documentStatuss : [],
			purchaseOrderDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getDocumentStatuss: async function (input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if(this.filter.poStatusId != undefined && input == '')
			{
				filter.id = this.filter.poStatusId;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.documentStatuss = result.data
					}
					this.isDocumentStatusComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			if(!this.filter.purchaseOrderDateFrom && !this.filter.purchaseOrderDateTo)
			{
				this.filter.show30DaysInAdvance = true
			} else {
				this.filter.show30DaysInAdvance = false
			}
			PurchaseOrder.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
					this.purchaseOrdersPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPurchaseOrdersWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			if(!this.filter.purchaseOrderDateFrom && !this.filter.purchaseOrderDateTo)
			{
				this.filter.show30DaysInAdvance = true
			} else {
				this.filter.show30DaysInAdvance = false
			}

			PurchaseOrder.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.purchaseOrders = result.data
					this.purchaseOrdersPaging = result
				}
			})
			.catch(error => {});
		},
		getPurchaseRequests : async function(input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			if(this.filter.purchaseRequestId != undefined && input == '')
			{
				filter.id = this.filter.purchaseRequestId;
			}
			PurchaseRequest.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseRequests = result.data
				}
			})
			.catch(error => {});
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(this.filter.vendorId != undefined && input == '')
			{
				filter.id = this.filter.vendorId;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		getVendorsByContactPerson : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.contactPerson = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new PurchaseOrderFilter();
			this.getPurchaseOrders();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPurchaseOrders();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PurchaseOrder.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PurchaseOrder.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			if(!this.filter.purchaseOrderDateFrom && !this.filter.purchaseOrderDateTo)
			{
				this.filter.show30DaysInAdvance = true
			} else {
				this.filter.show30DaysInAdvance = false
			}
			PurchaseOrder.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			PurchaseOrder.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'purchaseorderedit';
						if(this.isScannerMode) {
							createRoute = 'purchaseorderscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PurchaseOrder.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'purchaseorderedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PurchaseOrder.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPurchaseOrders();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PurchaseOrder.deleteMultipleData(this).then(result => {
					this.getPurchaseOrders();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePurchaseOrderParent = document.getElementById('table-list-purchaseorder').parentNode;
			tablePurchaseOrderParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePurchaseOrderParent.scrollWidth - tablePurchaseOrderParent.offsetWidth) == Math.ceil(tablePurchaseOrderParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePurchaseOrderParent = document.getElementById('table-list-purchaseorder').parentNode;
			tablePurchaseOrderParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePurchaseOrderParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PurchaseOrderFilter();
		this.getPurchaseRequests()
		this.getVendors()
		this.getDocumentStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Purchase Order"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPurchaseOrders();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPurchaseOrders();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPurchaseOrders();
			}
		},
		currentPage: {
			handler: function() {
				this.getPurchaseOrders();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPurchaseOrders();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PurchaseOrder.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "purchaseorderindex") {
					this.getPurchaseOrdersWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "purchase_order").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
